export default __webpack_public_path__ + "static/photo-amandine-be8f56b40af6bf148b2d299375347442.webp";